<template>
    <div class="modal_change_chip">
        <div class="modal_change_chip_card" :class="{'ac-bg-gray': ac}">
            <div class="modal_change_chip_close">
                <button v-if="closeButtonActive" :class="{'information_btn_close-ac': ac, 'information_btn_close': !ac}" @click.prevent="$emit('close')"></button>
            </div>
            <section class="modal_change_chip_type">
                <i :class="{ 'modal_change_chip_success' : success, 'modal_change_chip_danger': danger, 'modal_change_chip_warning': warning}" v-if="!ac"></i>
                <i :class="{ 'ac-modal_change_chip_success' : success, 'ac-modal_change_chip_danger': danger, 'ac-modal_change_chip_warning': warning}" v-if="ac"></i>
            </section>
            <h2 class="modal_change_chip_description" v-html="description" :class="{'ac-color-white': ac}"></h2>
            <div class="box_description">
                <div class="details_description">
                    <img src="/trocachip/img/iconChip.svg" alt="img-chip" title="changechip" />
                    <span class="icons_position" v-html="messageChip" :class="{'ac-color-white': ac}"></span>
                </div>
                <div class="details_description">
                    <img  src="/trocachip/img/gift.svg" alt="img-gift" title="gift" />
                    <span class="icons_position" v-html="messageGift" :class="{'ac-color-white': ac}"></span>
                </div>
            </div>            
            <div class="modal_change_chip_container_button">
                <button class="modal_change_chip_btn_close_button" :class="{'ac-color-black': ac, 'ac-bg-yellow': ac}" @click.prevent="closemodal_change_chip">{{ action }}</button>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import trackEvent from "../services/trackEvent";

    export default {
        name: "ModalChangeChip",
        props: {
            success: {
                default: false
            },
            closeButtonActive: {
                default: true
            },
            danger: {
                default: false
            },
            warning: {
                default: true
            },
            description: {
                default: "Veja mais detalhes para fazer sua troca de chip"
            },
            messageChip: {
                default: "O seu novo TIM chip 4G deve ser do <b>mesmo DDD do seu anterior.</b>"
            },
            messageGift: {
                default: "Mantenha o TIM chip 4G na embalagem. Ela tem informações que usaremos na troca."
            },
            action: {
                default: "Fechar"
            },
            tracker: {
                default: null
            }
        },
        data() {
            return {
                changeChipModal: '',
            };
        },
        created(){
            this.dispachEventTrack("screen_mais_detalhes_troca_chip", 3)
        },
        computed: mapState({
            ac: state => state.ac,
            customer: state => state.customer,
        }),
        methods: {
            closemodal_change_chip() {
                this.dispachEventTrack("fechar_mais_detalhes")
                if(this.tracker) this.dispachEventTrack(this.tracker)
                this.$emit('close')
            },
            dispachEventTrack(label,  eventAction = 2) {
                trackEvent.track({
                user: {
                    login: this.customer.login,
                    loginType: this.customer.loginType,
                    lineType: this.customer.lineType,
                    segment: this.customer.segment,
                    subSegment: this.customer.subSegment,
                    planCode: this.customer.planCode,
                    planName: this.customer.planName,
                },
                channel: trackEvent.getChannel(),
                "event-category": 6,
                "event-action": eventAction,
                "event-label": label,
                "event-location": "mvp esim",
                "event-value": this.customer.isExOiCustomer ? "oi" : "tim",
                "event-status": "Sucesso",			
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .modal_change_chip {
        width: 100%;
        height: 100vh;
        display: flex;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1005;
        background: rgba(0,0,0,0.6);
        overflow-y: auto;
        > .modal_change_chip_card {
            width: 335px;
            min-height: 526px;
            position: relative;
            display: block;
            margin: 0 auto;
            border-radius: 16px;
            box-shadow: 0 24px 50px 0 rgba(0, 0, 0, 0.2);
            background-color: #ffffff;
            padding-bottom: 2.5rem;
            > .modal_change_chip_close {
                width: 100%;
                height: 17px;
                margin: 25px auto;
                display: block;
                position: relative;
                z-index: 2;
                > .modal_change_chip_btn_close {
                    width: 17px;
                    height: 17px;
                    float: right;
                    display: block;
                    position: relative;
                    z-index: 3;
                    background: url("../assets/images/close.svg") no-repeat;
                    border: 0;
                    margin-right: 25px;
                }
                > .information_btn_close {
                    width: 17px;
                    height: 17px;
                    float: right;
                    display: block;
                    position: relative;
                    z-index: 3;
                    background: url("../assets/images/close.svg") no-repeat;
                    border: 0;
                    margin-right: 25px;
                }
                > .information_btn_close-ac {
                    width: 17px;
                    height: 17px;
                    float: right;
                    display: block;
                    position: relative;
                    z-index: 3;
                    background: url("../assets/images/close-ac.png") no-repeat !important;
                    border: 0;
                    margin-right: 25px;
                }
            }
            > .modal_change_chip_type {
                width: 100%;
                height: 60px;
                display: block;
                position: relative;
                margin-top: 40px;
                > .modal_change_chip_success {
                    width: 60px;
                    height: 60px;
                    display: block;
                    position: relative;
                    margin: 0 auto;
                    border-radius: 60px;
                    background: url("../assets/images/path.png") no-repeat;
                    background-position: center;
                }
                > .ac-modal_change_chip_success {
                    width: 60px;
                    height: 60px;
                    display: block;
                    position: relative;
                    margin: 0 auto;
                    border-radius: 60px;
                    background: url("../assets/images/path-ac.png") no-repeat;
                    background-position: center;
                }
                > .ac-modal_change_chip_danger {
                    width: 60px;
                    height: 60px;
                    display: block;
                    position: relative;
                    margin: 0 auto;
                    border-radius: 60px;
                    background: url("../assets/images/danger-ac.svg") no-repeat;
                    background-position: center;
                }
                > .modal_change_chip_danger {
                    width: 60px;
                    height: 60px;
                    display: block;
                    position: relative;
                    margin: 0 auto;
                    border-radius: 60px;
                    background: url("../assets/images/danger.svg") no-repeat;
                    background-position: center;
                }
                > .modal_change_chip_warning {
                    width: 60px;
                    height: 60px;
                    display: block;
                    position: relative;
                    margin: 0 auto;
                    border-radius: 60px;
                    background: url("/trocachip/img/Interrogação.svg") no-repeat;
                    background-position: center;
                }
                > .ac-modal_change_chip_warning {
                    width: 60px;
                    height: 60px;
                    display: block;
                    position: relative;
                    margin: 0 auto;
                    border-radius: 60px;
                    background: url("/trocachip/img/Interrogação-ac.svg") no-repeat;
                    background-position: center;
                }
            }
            > .modal_change_chip_description {
                width: 289px;
                min-height: 10px;
                margin: 42px 22px 0 24px;
                font-family: "timsans_regular";
                font-size: 24px;
                font-weight: 300;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: center;
                color: #000000;
            }
            > .modal_change_chip_message {
                width: 240px;
                min-height: 10px;
                display: block;
                margin: 24px auto 0 auto;
                font-family: 'timsans_regular';
                font-size: 1em;
                line-height: 1.5;
                letter-spacing: -0.2px;
                text-align: center;
                color: #666666;
            }
            > .modal_change_chip_container_button {
                width: 100%;
                height: auto;
                display: block;
                position: relative;
                margin-top: 40px;
                > .modal_change_chip_btn_close_button {
                    width: 286px;
                    min-height: 52px;
                    margin: 0 auto;
                    padding: 16px 0;
                    position: relative;
                    display: grid;
                    border-radius: 26px;
                    box-sizing: border-box;
                    background-color: #003091;
                    color: #ffffff;
                    border: none;
                    font-family: 'timsans_regular';
                    font-size: 1em;
                    text-align: center;
                }
            }
        }
    }
    .details_description {
    padding-top: 24px;
    font-family: "timsans_regular";
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.20000000298023224px;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    vertical-align: middle;
    width: 270px;
    float: left;
    color: #707376;
    }
    .icons_position {
    margin-top: 0 !important;
    padding-left: 18px;
    width: 250px;
    }
    .box_description {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    }
    @media (min-width: 768px) {
        .modal_change_chip {
            width: 100%;
            height: 100vh;
            display: flex;
            align-items: center;
            position: fixed;
            top: 0;
            left: 0;
            z-index: 1005;
            background: rgba(0,0,0,0.6);
            overflow-y: auto;
            > .modal_change_chip_card {
                width: 482px;
                min-height: 426px;
                position: relative;
                display: block;
                margin: 0 auto;
                border-radius: 16px;
                box-shadow: 0 24px 50px 0 rgba(0, 0, 0, 0.2);
                background-color: #ffffff;
                
                > .modal_change_chip_close {
                    width: 100%;
                    height: 17px;
                    margin: 25px auto;
                    display: block;
                    position: relative;
                    z-index: 2;
                    > .modal_change_chip_btn_close {
                        width: 17px;
                        height: 17px;
                        float: right;
                        display: block;
                        position: relative;
                        z-index: 3;
                        background: url("../assets/images/close.svg") no-repeat;
                        border: 0;
                        margin-right: 25px;
                    }
                    > .information_btn_close {
                        width: 17px;
                        height: 17px;
                        float: right;
                        display: block;
                        position: relative;
                        z-index: 3;
                        background: url("../assets/images/close.svg") no-repeat;
                        border: 0;
                        margin-right: 25px;
                    }
                    > .information_btn_close-ac {
                        width: 17px;
                        height: 17px;
                        float: right;
                        display: block;
                        position: relative;
                        z-index: 3;
                        background: url("../assets/images/close-ac.png") no-repeat !important;
                        border: 0;
                        margin-right: 25px;
                    }
                }
                > .modal_change_chip_type {
                    width: 100%;
                    height: 60px;
                    display: block;
                    position: relative;
                    margin-top: 40px;
                    > .modal_change_chip_success {
                        width: 60px;
                        height: 60px;
                        display: block;
                        position: relative;
                        margin: 0 auto;
                        border-radius: 60px;
                        background: url("../assets/images/path.png") no-repeat;
                        background-position: center;
                    }
                    > .ac-modal_change_chip_success {
                        width: 60px;
                        height: 60px;
                        display: block;
                        position: relative;
                        margin: 0 auto;
                        border-radius: 60px;
                        background: url("../assets/images/path-ac.png") no-repeat;
                        background-position: center;
                    }
                    > .ac-modal_change_chip_danger {
                        width: 60px;
                        height: 60px;
                        display: block;
                        position: relative;
                        margin: 0 auto;
                        border-radius: 60px;
                        background: url("../assets/images/danger-ac.svg") no-repeat;
                        background-position: center;
                    }
                    > .modal_change_chip_danger {
                        width: 60px;
                        height: 60px;
                        display: block;
                        position: relative;
                        margin: 0 auto;
                        border-radius: 60px;
                        background: url("../assets/images/danger.svg") no-repeat;
                        background-position: center;
                    }
                    > .modal_change_chip_warning {
                        width: 60px;
                        height: 60px;
                        display: block;
                        position: relative;
                        margin: 0 auto;
                        border-radius: 60px;
                        background: url("/trocachip/img/Interrogação.svg") no-repeat;
                        background-position: center;
                    }
                    > .ac-modal_change_chip_warning {
                        width: 60px;
                        height: 60px;
                        display: block;
                        position: relative;
                        margin: 0 auto;
                        border-radius: 60px;
                        background: url("/trocachip/img/Interrogação-ac.svg") no-repeat;
                        background-position: center;
                    }
                }
                > .modal_change_chip_description {
                    width: 415px;
                    min-height: 10px;
                    margin: 42px 22px 0 24px;
                    font-family: "timsans_regular";
                    font-size: 24px;
                    font-weight: 300;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    text-align: center;
                    color: #000000;
                }
                > .modal_change_chip_message {
                    width: 366px;
                    min-height: 10px;
                    display: block;
                    margin: 24px auto 0 auto;
                    font-family: 'timsans_regular';
                    font-size: 1em;
                    line-height: 1.5;
                    letter-spacing: -0.2px;
                    text-align: center;
                    color: #666666;
                }
                > .modal_change_chip_container_button {
                    width: 100%;
                    height: auto;
                    display: block;
                    position: relative;
                    margin-top: 40px;
                    > .modal_change_chip_btn_close_button {
                        width: 286px;
                        min-height: 52px;
                        margin: 0 auto;
                        padding: 16px 0;
                        position: relative;
                        display: grid;
                        border-radius: 26px;
                        box-sizing: border-box;
                        background-color: #003091;
                        color: #ffffff;
                        border: none;
                        font-family: 'timsans_regular';
                        font-size: 1em;
                        text-align: center;
                    }
                }
            }
        }
    }
    .details_description {
    padding-top: 24px;
    font-family: "timsans_regular";
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.20000000298023224px;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    vertical-align: middle;
    width: 270px;
    float: left;
    color: #707376;
    }
    .icons_position {
    margin-top: 0 !important;
    padding-left: 18px;
    width: 250px;
    }
</style>
